module.exports = __webpack_public_path__ + "img/spd.0c1542e4.png";